import { render } from "./SustainabilityReport2025.vue?vue&type=template&id=4e7a9263&scoped=true"
import script from "./SustainabilityReport2025.vue?vue&type=script&lang=js"
export * from "./SustainabilityReport2025.vue?vue&type=script&lang=js"

import "./SustainabilityReport2025.vue?vue&type=style&index=0&id=4e7a9263&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e7a9263"]])

export default __exports__